<template>
  <el-tabs v-if="!hideFormSettingPanel || data" v-model="activeName" @tab-click="handleClick">
    <el-tab-pane v-if="data" label="组件设置" name="componentSetting">
      <slot v-if="custom" type="SettingForm" :data="data" />
      <which-element v-else type="SettingForm" :data="data" />
    </el-tab-pane>
    <el-tab-pane v-if="!hideFormSettingPanel" label="表单设置" name="formSetting" class="he-layout--right--form-setting">
      <el-form label-position="right" :model="formData.formStyle" label-width="100px" size="small">
        <el-form-item v-if="checkHideSetting(ItemEnum.SETTINGS.HIDELABEL)" label="隐藏标签">
          <el-switch
            v-model="formData.formStyle.hideLabel"
            active-text="是"
            inactive-text="否"
          />
        </el-form-item>
        <el-form-item v-if="checkHideSetting(ItemEnum.SETTINGS.LABELWIDTH)" label="标签宽度" prop="labelWidth" :rules="[{required: true, message: '必填', trigger: 'blur'}]">
          <el-input v-model="formData.formStyle.labelWidth" placeholder="标签字段宽度单位px" />
        </el-form-item>
        <el-form-item v-if="checkHideSetting(ItemEnum.SETTINGS.LABELSUFFIX)" label="标签后缀" prop="labelSuffix">
          <el-input v-model="formData.formStyle.labelSuffix" placeholder="标签字段后缀" />
        </el-form-item>
        <el-form-item v-if="checkHideSetting(ItemEnum.SETTINGS.LABELPOSITION)" label="标签位置">
          <el-radio-group v-model="formData.formStyle.labelPosition">
            <el-radio-button label="top">居上</el-radio-button>
            <el-radio-button label="left">居左</el-radio-button>
            <el-radio-button label="right">居右</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="checkHideSetting(ItemEnum.SETTINGS.SIZE)" label="组件尺寸">
          <el-radio-group v-model="formData.formStyle.size">
            <el-radio-button label="">偏大</el-radio-button>
            <el-radio-button label="medium">中等</el-radio-button>
            <el-radio-button label="small">偏小</el-radio-button>
            <el-radio-button label="mini">迷你</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="checkHideSetting(ItemEnum.SETTINGS.REQUIREDASTERISK)" label="必填星号">
          <el-switch
            v-model="formData.formStyle.showRequiredAsterisk"
            active-text="显示"
            inactive-text="隐藏"
          />
        </el-form-item>
        <el-form-item v-if="checkHideSetting(ItemEnum.SETTINGS.VERIFYMSG)" label="验证提示">
          <el-switch
            v-model="formData.formStyle.showVerificationMessage"
            active-text="显示"
            inactive-text="隐藏"
          />
        </el-form-item>
      </el-form>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { WhichElement, ItemEnum } from '../index.js'
export default {
  name: 'Setting',
  components: { WhichElement },
   inject: {
    formData: {
      default: () => {}
    }
  },
  props: {
    custom: Boolean,
    data: {
      type: [Object, null],
      default: null
    },
    hideFormSettingPanel: Boolean,
    hideFormSettings: {
      type: [Array, String],
      default: ''
    }
  },
  data() {
    return {
      ItemEnum,
      activeName: 'formSetting'
    }
  },
  watch: {
    'formData.formStyle.hideLabel': function(v) {
      if (v) {
        this.formData.formStyle.labelWidth = '0'
      } else {
        this.formData.formStyle.labelWidth = '100px'
      }
    },
    data(val, oldval) {
      this.activeName = val ? 'componentSetting' : 'formSetting'
    }
  },
  created() {
    this.activeName = this.data ? 'componentSetting' : 'formSetting'
  },
  methods: {
    checkHideSetting(formItemKey) {
      if (typeof this.hideFormSettings === 'string') {
        return this.hideFormSettings !== formItemKey
      } else if (Object.prototype.toString.call(this.hideFormSettings) === '[object Array]' && this.hideFormSettings.length) {
        return !this.hideFormSettings.find(item => item === formItemKey)
      } else {
        return true
      }
    },
    handleClick(tab) {
      // console.log(tab);
    }
  }
}
</script>
<style lang="scss">
@import '../../index.scss';
.he-layout--right {
  .el-tabs__nav {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;
    width: 100%;

    .el-tabs__item {
      padding: 0;
      box-sizing: border-box;
      &.is-active {
        border-bottom: 2px solid $primary-color;
      }
    }

    .el-tabs__active-bar {
      display: none;
    }
  }

  .el-tabs__content {
    box-sizing: border-box;
    padding: 0 10px;
  }

}
</style>
